export const GemXIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_12098_19932)">
      <g clipPath="url(#clip1_12098_19932)">
        <rect width="20" height="20" rx="0.234474" fill="#151515" />
        <g clipPath="url(#clip2_12098_19932)">
          <path
            d="M11.4813 3.1628L10.309 5.28184C10.2993 5.3008 10.2993 5.3245 10.309 5.34347L12.823 9.88969C12.8473 9.93472 12.9127 9.93472 12.9369 9.88969L16.984 2.57259C17.0082 2.52993 16.9767 2.47778 16.9259 2.47778H12.6559C12.1643 2.47778 11.7138 2.74089 11.4813 3.1628Z"
            fill="#F34A70"
          />
          <path
            d="M7.69579 2.47754H3.35076C3.22723 2.47754 3.14731 2.60791 3.20786 2.71457L7.22835 9.98663L3.20544 17.2634C3.14731 17.3701 3.22481 17.5005 3.35076 17.5005H7.68611C7.78299 17.5005 7.87502 17.4483 7.92104 17.363L11.9415 10.0909C11.9803 10.0222 11.9803 9.93685 11.9415 9.86811L7.93073 2.61502C7.88471 2.52969 7.7951 2.47754 7.69579 2.47754Z"
            fill="#2C7DFF"
          />
          <path
            d="M11.4813 16.8371L10.309 14.718C10.2993 14.6991 10.2993 14.6754 10.309 14.6564L12.823 10.1102C12.8473 10.0652 12.9127 10.0652 12.9369 10.1102L16.9816 17.4273C17.0058 17.47 16.9743 17.5221 16.9235 17.5221H12.6535C12.1618 17.5221 11.7114 17.259 11.4788 16.8371H11.4813Z"
            fill="#F34A70"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_12098_19932">
        <rect width="20" height="20" rx="2" fill="white" />
      </clipPath>
      <clipPath id="clip1_12098_19932">
        <rect width="20" height="20" fill="white" />
      </clipPath>
      <clipPath id="clip2_12098_19932">
        <rect
          width="13.8053"
          height="15.0442"
          fill="white"
          transform="translate(3.18579 2.47778)"
        />
      </clipPath>
    </defs>
  </svg>
);
